import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Typography, Button } from "@mui/material";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  uploadButton: {
    cursor: "pointer",
    textTransform: "none",
    whiteSpace: "nowrap"
  }
}));

function UploadButton(props) {
  const classes = useStyles();
  const {
    onUpload,
    acceptType,
    buttonText,
    buttonId,
    buttonVariant,
    labelVariant,
    icon,
    buttonClassName,
    multiple,
    disabled
  } = props;
  return (
    <>
      <input
        style={{ display: "none" }}
        accept={acceptType}
        id={buttonId}
        multiple={multiple}
        type="file"
        onChange={onUpload}
        disabled={disabled}
      />
      <label className={classes.uploadButton} htmlFor={buttonId}>
        <Button
          color="primary"
          variant={buttonVariant}
          startIcon={icon}
          className={buttonClassName}
          component="span"
          disabled={disabled}
        >
          <Typography variant={labelVariant}>{buttonText}</Typography>
        </Button>
      </label>
    </>
  );
}

export default UploadButton;

UploadButton.propTypes = {
  buttonText: PropTypes.string,
  acceptType: PropTypes.string,
  buttonId: PropTypes.string,
  onUpload: PropTypes.func,
  buttonVariant: PropTypes.string,
  labelVariant: PropTypes.string,
  buttonClassName: PropTypes.string,
  icon: PropTypes.node,
  multiple: PropTypes.bool
};

UploadButton.defaultProps = {
  buttonVariant: "outlined",
  acceptType: "image/*",
  labelVariant: "button",
  icon: null,
  multiple: true
};
